export default "__VITE_ASSET__K6k41Qy3__"